"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayDisplayModeChangeRequestT = exports.OverlayDisplayModeChangeRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Changes the state of the overlay's display mode.
 */
class OverlayDisplayModeChangeRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOverlayDisplayModeChangeRequest(bb, obj) {
        return (obj || new OverlayDisplayModeChangeRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOverlayDisplayModeChangeRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OverlayDisplayModeChangeRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    isVisible() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    isMirrored() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : null;
    }
    static startOverlayDisplayModeChangeRequest(builder) {
        builder.startObject(2);
    }
    static addIsVisible(builder, isVisible) {
        builder.addFieldInt8(0, +isVisible, 0);
    }
    static addIsMirrored(builder, isMirrored) {
        builder.addFieldInt8(1, +isMirrored, 0);
    }
    static endOverlayDisplayModeChangeRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOverlayDisplayModeChangeRequest(builder, isVisible, isMirrored) {
        OverlayDisplayModeChangeRequest.startOverlayDisplayModeChangeRequest(builder);
        if (isVisible !== null)
            OverlayDisplayModeChangeRequest.addIsVisible(builder, isVisible);
        if (isMirrored !== null)
            OverlayDisplayModeChangeRequest.addIsMirrored(builder, isMirrored);
        return OverlayDisplayModeChangeRequest.endOverlayDisplayModeChangeRequest(builder);
    }
    unpack() {
        return new OverlayDisplayModeChangeRequestT(this.isVisible(), this.isMirrored());
    }
    unpackTo(_o) {
        _o.isVisible = this.isVisible();
        _o.isMirrored = this.isMirrored();
    }
}
exports.OverlayDisplayModeChangeRequest = OverlayDisplayModeChangeRequest;
class OverlayDisplayModeChangeRequestT {
    constructor(isVisible = null, isMirrored = null) {
        this.isVisible = isVisible;
        this.isMirrored = isMirrored;
    }
    pack(builder) {
        return OverlayDisplayModeChangeRequest.createOverlayDisplayModeChangeRequest(builder, this.isVisible, this.isMirrored);
    }
}
exports.OverlayDisplayModeChangeRequestT = OverlayDisplayModeChangeRequestT;
